const SuccessModal = ({ show, onClose, message }) => {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal"> 
        <span className="modal-icon"> 🎉 </span>
        <h2 className="custom-modal-title"> Submitted Successfully</h2>
        <p>{message || "Your session request has been submitted successfully. You will receive an email shortly."}</p> 
        <button onClick={onClose} className="modal-btn">
          OK
        </button> 
      </div>
    </div>
  );
};

export default SuccessModal;
